"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendGaEvent = exports.transformObjectKeysToGaFormat = exports.extractMainProperties = exports.extractUserProperties = exports.convertPathToPageName = exports.buildCMSEventObj = exports.sendCMSEvent = exports.extractComponentTagging = exports.checkEventObj = exports.createEventObject = exports.createPageEventObject = exports.TAG_EVENT_TYPES = exports.ERROR_REQUIRED_KEYS = exports.REQUIRED_KEYS_KEBAP = exports.REQUIRED_KEYS = void 0;
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
exports.REQUIRED_KEYS = [
    "componentVariation",
    "componentContent",
    "componentProduct",
];
exports.REQUIRED_KEYS_KEBAP = [
    "component-variation",
    "component-content",
    "component-product",
];
exports.ERROR_REQUIRED_KEYS = ["eventType", "errorDetail", "errorOrigin"];
exports.TAG_EVENT_TYPES = {
    CLICK: "click",
    SCROLL: "scroll",
};
const createPageEventObject = (data) => {
    if (!data) {
        return null;
    }
    const { clientIDs, userType: userTypeFromData } = data;
    const { event = "cms-page", eventType = "", tabId = "", pageName = "", pageProductCode = "", pageProductName = "", contextGaCookie = (clientIDs && clientIDs.ga) || null, contextSessionId = (clientIDs && clientIDs.sessId) || null, contextPageId = (clientIDs && clientIDs.pageId) || null, userCUCFijoHash = "", userCUCMovilHash = "", userCUCPrepagoHash = "", userIPHash = "", userOperadorHash = "", userTelefonoFijoHash = "", userTelefonoMovilHash = "", userIdPartyHash = "", userType = "", userConsentCookieOneTrust = "", pageSegment = "", contextURL = "", testVersion = "", testName = "", userClient = !!userTypeFromData, userPriority = "", contextSeoMeta = "", } = data;
    return {
        event,
        "event-type": eventType,
        "context-tab-id": tabId,
        "page-name": pageName,
        "page-product-code": pageProductCode,
        "page-product-name": pageProductName,
        // client id de ga
        "context-ga-cookie": contextGaCookie,
        // id de sesión de la navegación del usuario
        "context-session-id": contextSessionId,
        // page id de la página
        "context-page-id": contextPageId,
        "user-cuc-fijo-hash": userCUCFijoHash,
        "user-cuc-movil-hash": userCUCMovilHash,
        "user-cuc-prepago-hash": userCUCPrepagoHash,
        "user-ip-hash": userIPHash,
        "user-operador-hash": userOperadorHash,
        "user-telefono-fijo-hash": userTelefonoFijoHash,
        "user-telefono-movil-hash": userTelefonoMovilHash,
        "user-id-party-hash": userIdPartyHash,
        // telco o legado
        "user-type": userType,
        // estado consentimientos cookies del usuario
        "user-consent-cookie-onetrust": userConsentCookieOneTrust,
        // segmento de navegación de la página
        "page-segment": pageSegment,
        // url de la página
        "context-url": contextURL,
        "test-version": testVersion,
        "test-name": testName,
        // true o false si es cliente o no
        "user-client": userClient,
        // true o false si es priority o no
        "user-priority": userPriority,
        // meta description de seo
        "context-seo-meta": contextSeoMeta,
    };
};
exports.createPageEventObject = createPageEventObject;
/**
 * Crea el objeto con la estructura adecuada para un evento de componente de métricas
 * @param {String} eventType
 * @param {String} componentName
 * @param {String} componentVariation
 * @param {String} componentContent
 * @param {String} componentProduct
 * @param {Object} componentPerso
 * @param {String} event
 */
const createEventObject = (inputObj, eventType = exports.TAG_EVENT_TYPES.CLICK) => {
    const finalRes = {
        event: "cms-component",
        "event-type": eventType,
        "component-name": "",
        "component-variation": "",
        "component-content": "",
        "component-product": "",
        "component-perso": {},
    };
    const keys = inputObj ? Object.keys(inputObj) : [];
    keys.forEach((key) => {
        const resKey = (0, next12_utils_common_1.toKebabCase)(key);
        let resValue = inputObj[key];
        if (typeof resValue === "string") {
            resValue = (0, next12_utils_common_1.normalizeString)(resValue);
        }
        finalRes[resKey] = resValue;
        finalRes[resKey] = finalRes[resKey] || "";
    });
    return finalRes;
};
exports.createEventObject = createEventObject;
const checkEventObj = (taggingInfo) => {
    let res = true;
    exports.REQUIRED_KEYS.forEach((key, index) => {
        const keyKebapAlternative = exports.REQUIRED_KEYS_KEBAP[index];
        if (typeof taggingInfo[key] === "undefined" &&
            typeof taggingInfo[keyKebapAlternative] === "undefined") {
            res = false;
        }
    });
    if (taggingInfo.debug) {
        res = true;
    }
    return res;
};
exports.checkEventObj = checkEventObj;
/**
 * Envía a la cola adecuada de métricas un evento de componente.
 * @param {*} eventType
 * @param {*} componentName
 * @param {*} componentVariation
 * @param {*} componentContent
 * @param {*} componentProduct
 * @param {*} componentPerso
 */
const extractComponentTagging = (contextObj) => {
    let res = {
        event_type: contextObj["event_type"],
        component_name: contextObj["component_name"],
        component_content: contextObj["component_content"],
        component_product: contextObj["component_product"],
        component_perso: JSON.stringify(contextObj["component_perso"]),
        component_variation: contextObj["component_variation"],
    };
    return res;
};
exports.extractComponentTagging = extractComponentTagging;
const sendGaComponentEvent = (contextObj) => {
    if (contextObj && contextObj.event) {
        delete contextObj.event;
    }
    const componentTaggingInfo = (0, exports.extractComponentTagging)(contextObj);
    window.gtag("event", "cms_component", Object.assign({}, componentTaggingInfo));
};
const sendCMSEvent = (inputObj) => {
    const isFrontApp = typeof window !== "undefined";
    if (isFrontApp) {
        const checkObj = (0, exports.checkEventObj)(inputObj);
        const object = (0, exports.createEventObject)(inputObj);
        try {
            if (checkObj) {
                if (window && window.nookInfoExchange) {
                    window.nookInfoExchange.sendMessage("Metrics", object);
                }
                else if (`${process.env.NEXT_PUBLIC_GTM_USAGE}` === "false") {
                    (0, exports.sendGaEvent)(object);
                }
                else {
                    window.dataLayerGTM.push(object);
                }
            }
            else {
                console.error("TaggingInfo is no properly defined [checkEventObj] no right event structure");
            }
        }
        catch (err) {
            console.error("Maybe dataLayerGTM or nookInfoExchange are not defined");
        }
    }
};
exports.sendCMSEvent = sendCMSEvent;
const buildCMSEventObj = (kind = "print", status, eventFamily = "cms-component", id, customizerId, taggingInfo) => {
    const componentUuid = 1;
    const newEvent = `${kind}-${status}`;
    const event = Object.assign(Object.assign({}, taggingInfo), { event: eventFamily, eventType: newEvent, componentUuid });
    if (id) {
        event.componentName = id;
    }
    event.customizerId = customizerId;
    if (status === "204") {
        event.componentUuid = componentUuid;
    }
    // set necesary props to avoid checkEventObj
    if (!event.componentName) {
        event.componentName = "";
    }
    if (!event.componentVariation) {
        event.componentVariation = "";
    }
    if (!event.componentContent) {
        event.componentContent = "";
    }
    if (!event.componentProduct) {
        event.componentProduct = "";
    }
    return event;
};
exports.buildCMSEventObj = buildCMSEventObj;
/**
 * Funcion que recibe una cadena y la normaliza, reemplazando las / por :
 * @param {string} unnormalizedString cadena sin normalizar
 * @return {string} normalizedString cadena normalizada
 */
const replaceSlashToColon = (unnormalizedString) => {
    const normalizedString = unnormalizedString.replace(/\//g, ":");
    return normalizedString;
};
/**
 * Funcion que normaliza y retorna el pathname actual
 * @return {string} normalizedUrl pathname normalizado
 */
const convertPathToPageName = () => {
    let normalizedUrl = "";
    if (window && window.location) {
        const { pathname } = window.location;
        const pathNameWithoutFirstSlash = pathname.replace("/", "");
        normalizedUrl = replaceSlashToColon(pathNameWithoutFirstSlash).toLowerCase();
    }
    return normalizedUrl;
};
exports.convertPathToPageName = convertPathToPageName;
const extractUserProperties = (contextObj) => {
    let res = {
        context_ga_cookie: contextObj["context-ga-cookie"],
        user_client: contextObj["user-client"],
        user_consent_cookie_onetrust: contextObj["user-consent-cookie-onetrust"],
        user_cuc_fijo_hash: contextObj["user-cuc-fijo-hash"],
        user_cuc_movil_hash: contextObj["user-cuc-movil-hash"],
        user_cuc_prepago_hash: contextObj["user-cuc-prepago-hash"],
        user_id_party_hash: contextObj["user-id-party-hash"],
        user_ip_hash: contextObj["user-ip-hash"],
        user_operador_hash: contextObj["user-operador-hash"],
        user_priority: contextObj["user-priority"],
        user_telefono_fijo_hash: contextObj["user-telefono-fijo-hash"],
        user_telefono_movil_hash: contextObj["user-telefono-movil-hash"],
        user_type: contextObj["user-type"],
    };
    return res;
};
exports.extractUserProperties = extractUserProperties;
const extractMainProperties = (contextObj) => {
    let res = {
        page_name: contextObj["page-name"],
        page_product_code: contextObj["page-product-code"],
        page_product_name: contextObj["page-product-name"],
        page_segment: contextObj["page-segment"],
        context_page_id: contextObj["context-page-id"],
        context_seo_meta: contextObj["context-seo-meta"],
        context_session_id: contextObj["context-session-id"],
        context_tab_id: contextObj["context-tab-id"],
        context_url: contextObj["context-url"],
    };
    return res;
};
exports.extractMainProperties = extractMainProperties;
const sendGaPageEvent = (eventType) => {
    let eventValue = "page_printed";
    if (eventType === "view") {
        eventValue = "page_view";
    }
    window.gtag("event", eventValue);
};
const transformObjectKeysToGaFormat = (object) => {
    let result = {};
    const keys = object ? Object.keys(object) : [];
    keys.forEach((keyName) => {
        const newKey = keyName.replace(/-/g, "_");
        const value = object[keyName];
        result[newKey] = value;
    });
    return result;
};
exports.transformObjectKeysToGaFormat = transformObjectKeysToGaFormat;
const sendGaEvent = (contextObj) => {
    try {
        const gaObject = (0, exports.transformObjectKeysToGaFormat)(contextObj);
        const event = gaObject["event"];
        const eventType = gaObject["event_type"];
        const componentTagging = event.indexOf("component") !== -1;
        const printEvent = eventType.indexOf("print") !== -1;
        if (event === "cms-page" && eventType) {
            sendGaPageEvent(eventType);
        }
        else if (componentTagging || printEvent) {
            // para los eventos de customizer
            sendGaComponentEvent(gaObject);
        }
        else {
            window.gtag("event", gaObject);
        }
    }
    catch (err) {
        console.error(err);
    }
};
exports.sendGaEvent = sendGaEvent;
//# sourceMappingURL=index.js.map